import * as React from "react";

function SvgGoogleCloudPubSub(props, ref) {
  return (
    <svg
      id="GoogleCloud_PubSub_svg__Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 406.1 362.4"
      xmlSpace="preserve"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style>{".GoogleCloud_PubSub_svg__st2{fill:#fff}"}</style>
      <g
        id="GoogleCloud_PubSub_svg__PubSub_128px"
        transform="translate(297 79)"
      >
        <g id="GoogleCloud_PubSub_svg__BASE_2_">
          <linearGradient
            id="GoogleCloud_PubSub_svg__Shape_1_"
            gradientUnits="userSpaceOnUse"
            x1={-1099.264}
            y1={2340.803}
            x2={-1099.264}
            y2={2351.983}
            gradientTransform="matrix(35.6175 0 0 31.7029 39058.594 -74286.016)"
          >
            <stop offset={0} stopColor="#4387fd" />
            <stop offset={1} stopColor="#4683ea" />
          </linearGradient>
          <path
            id="GoogleCloud_PubSub_svg__Shape_8_"
            d="M-207.2 261.3L-289 119.6c-6.4-11.1-6.4-24.7 0-35.8l81.8-141.7c6.4-11.1 18.2-17.9 31-17.9h163.6c12.8 0 24.6 6.8 31 17.9l81.8 141.7c6.4 11.1 6.4 24.7 0 35.8L18.4 261.3c-6.4 11-18.2 17.9-31 17.9h-163.6c-12.8 0-24.6-6.9-31-17.9z"
            fill="url(#GoogleCloud_PubSub_svg__Shape_1_)"
          />
        </g>
        <g
          id="GoogleCloud_PubSub_svg__shadow_2_"
          transform="translate(10.574 7.513)"
          opacity={0.07}
        >
          <path
            id="GoogleCloud_PubSub_svg__Shape_9_"
            d="M72.8 142.7l-99.2-99.2-18.3 3.8-45.5-45.5-14.5 27.2-7.9 31.5 13.4 13.4-25.7 5.2-35.2-35.2-23.9 23 44 44-46.6 37.1 125.2 125.2 61-.6z"
          />
        </g>
        <g
          id="GoogleCloud_PubSub_svg__art_2_"
          transform="translate(10.017 6.957)"
        >
          <g id="GoogleCloud_PubSub_svg__Group_2_">
            <circle
              id="GoogleCloud_PubSub_svg__Oval"
              className="GoogleCloud_PubSub_svg__st2"
              cx={-37.4}
              cy={56}
              r={16.6}
            />
            <circle
              id="GoogleCloud_PubSub_svg__Oval_1_"
              className="GoogleCloud_PubSub_svg__st2"
              cx={-171.5}
              cy={56}
              r={16.6}
            />
            <circle
              id="GoogleCloud_PubSub_svg__Oval_2_"
              className="GoogleCloud_PubSub_svg__st2"
              cx={-104.4}
              cy={172.1}
              r={16.6}
            />
            <g id="GoogleCloud_PubSub_svg__Rectangle-path">
              <path
                transform="rotate(-60 -70.08 111.632)"
                className="GoogleCloud_PubSub_svg__st2"
                d="M-80.2 73.4h15.3v77.4h-15.3z"
              />
              <path
                transform="rotate(-30 -135.149 110.008)"
                className="GoogleCloud_PubSub_svg__st2"
                d="M-178.3 104.5h77.4v15.3h-77.4z"
              />
              <path
                className="GoogleCloud_PubSub_svg__st2"
                d="M-113.8 15.3h15.3v77.4h-15.3z"
                transform="translate(1.67 1.948)"
              />
            </g>
            <circle
              id="GoogleCloud_PubSub_svg__Oval_3_"
              className="GoogleCloud_PubSub_svg__st2"
              cx={-104.4}
              cy={94.7}
              r={26.8}
            />
            <circle
              id="GoogleCloud_PubSub_svg__Oval_4_"
              className="GoogleCloud_PubSub_svg__st2"
              cx={-171.5}
              cy={133.4}
              r={21.1}
            />
            <circle
              id="GoogleCloud_PubSub_svg__Oval_5_"
              className="GoogleCloud_PubSub_svg__st2"
              cx={-37.4}
              cy={133.4}
              r={21.1}
            />
            <circle
              id="GoogleCloud_PubSub_svg__Oval_6_"
              className="GoogleCloud_PubSub_svg__st2"
              cx={-104.4}
              cy={17.3}
              r={21.1}
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgGoogleCloudPubSub);
